import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AssessmentService } from "../assessment.service";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { forkJoin, lastValueFrom, map, switchMap } from "rxjs";
import { JobService } from "../../jobs/jobs.service";
// import { IMyDpOptions } from "mydatepicker";
import { ListOfCandidatesComponent } from "../list-of-candidates/list-of-candidates.component";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog } from "@angular/material/dialog";
import { EvaluatorComponent } from "../evaluator/evaluator.component";
import { Overlay } from "@angular/cdk/overlay";
import { DeleteDialogComponent } from "../../shared/components/delete-dialog/delete-dialog.component";

declare let myExtObject: any;
declare let $: any;

@Component({
  selector: "app-assessment-details",
  templateUrl: "./assessment-details.component.html",
  styleUrls: ["./assessment-details.component.css"],
  providers: [AssessmentService, JobService],
  standalone: false,
})
export class AssessmentDetailsComponent implements OnInit, OnDestroy {
  @ViewChild(ListOfCandidatesComponent)
  listOfCandidatesComponent: ListOfCandidatesComponent;
  selectedAssigneeDetails: any;
  availableAssignees: any = [];
  linkId: any;
  centerMngrAssignedTo: string = "";
  setCenterMangerFlag: boolean;
  noCenterManagerFlag: boolean = false;
  selAssigneeId = "";
  selectedMediaUrl: string | null = null;
  selectedMediaType: string | null = null;
  fillInTheBlanksQuesn = "";
  hideSelectAssigneeOption = false;
  assigneeRole = { evaluate: false, proctor: false, centerManager: false };
  batchReferenceId: any;
  selectedBatch: any;
  assignEvaluatorConfirmationMessage = "";
  unlinkAssigneeConfirmationMessage = "";
  removeAssigneeActionType = "";
  userRole: any;
  userDetails: any;
  assessmentDescriptionDash: any;
  assessmentDetails: any;
  companyId: any;
  accessToken: any;
  showSectionQuestion: Boolean = false;
  showCandidatelinkName: Boolean = true;
  questionAnswerSave: any = [];
  showAssessemt: Boolean;
  assessmentList1: Boolean;
  assessmentData: Boolean = true;
  assessmentConfigurationDash: Boolean = false;
  assessmentListOfCandidates: Boolean = false;
  assessmentCandidatesDetails: Boolean = false;
  asseementQuestion: Boolean = false;
  sectionIndex: any;
  questionAnswer: any;
  errorMsg: any;
  assessmentNumQuestion: any = [];
  assessmentQuestionType: any = [];
  sectionWiseQuestionDetail: any = [];
  createdassessmentId: String = "";
  assessmentSection: any = [];
  candidateSearchText: string = "";
  QuestionType: any;
  trackGeoLocation = {
    startLocation: {
      latitude: "",
      location: "",
      longitude: "",
      reverseGeo: "",
    },
    endLocation: {
      latitude: "",
      location: "",
      longitude: "",
      reverseGeo: "",
    },
  };
  listOfLinkForAssessment: Boolean;
  isRequestInProcess: Boolean = false;
  skipforLinkList: any;
  listofLinkDetails: any;
  publicLinkcreateion = "";
  listMessage: Boolean;
  listErrMessage: Boolean = false;
  assessmentTypeList = [];
  tagsForLink: any;
  typeOfQuestion: any;
  levelOfQuestion: any;
  assessmentTypeForLoadMore = "";
  isDetails: Boolean = true;
  companyType: any;
  proctor: any;
  proctorLinkId: any;
  editId: any;
  subCatDetails = [{ categories: [] }];
  publicSTARTDate: any;
  publicENDDate: any;
  publicLinkCreation: Boolean;
  privateLinkCreationStep1: Boolean;
  privateLinkCreationStep2: Boolean;
  Testcode = "";
  linkIdDeleted = "";
  option1 = "1";
  option2 = "2";
  option3 = "3";
  option4 = "4";
  CandidatelinkName = "";
  CandidatelinkID = "";
  CandidatelinkType = "";
  CandidateTrackLocation: boolean;
  candidateListValue;
  CandidateSnap: Boolean = false;
  CandidateStartDT;
  CandidateEndDT;
  candidateLocation = "";
  candidateListForLink: boolean;
  skipforCan = 0;
  addLinkID = "";
  candidateReportResponse = [];
  CandidateReportDetails: Boolean = false;
  assessmentIdDelete: any;
  instructForTest: Boolean = true;
  instructForTestValue = "Instructions not included";
  afterTestMessage: Boolean = true;
  afterTestMessageValue = "Thank you for taking assessment";
  imageUploadForLink: boolean;
  publicStartDate = "";
  publicStartTime = "";
  publicEndDate = "";
  publicEndTime = "";
  publicerrorMsg = "";
  mobileNum: string;
  countryCodeNum: string;
  modalResetCandidate: FormGroup;
  selectedRowMobileNumber: string;
  selectedRowCountryCode: string;
  selectRow = 0;
  isUploadingCandImg: Boolean = false;
  uploadedFileErrMsg: string;
  afterSelect = false;
  base64textString = "";
  responseUrlImage = "";
  lessChar: boolean = false;
  date = new Date();
  currentYear = this.date.getFullYear();
  currentMonth = this.date.getMonth() + 1;
  currentDate = this.date.getDate();
  candidateSearchTextTag: string = "";
  searchTextTag: string = "";
  candidateSearchText1: string = "";
  searchFlag: boolean = false;

  CandidateReportData = [];
  CandidateData;
  candidateCaputerdSnapshot = [];
  candidateAttendanceSnapshot = "";
  @ViewChild("gmapstart", { static: false }) gmapElementstart: any;
  @ViewChild("gmapstart1", { static: false }) gmapElementstart1: any;
  @ViewChild("gmapend", { static: false }) gmapElementend: any;
  @ViewChild("myVideo") myVideo: ElementRef;
  marker: any;
  location: string;
  startLocation: string;
  endLocation: string;
  data: any;
  totalNumQuestion: any;
  nodeValue: any = [];
  previewOfAssessmentList: any = [];
  easy = "EASY";
  medium = "MEDIUM";
  hard = "HARD";
  reviewDetails: any = [];
  descriptiveMarks: any = [];
  isReviewLoading: Boolean = false;

  linkData: any = {};
  countryCode: any;
  reviewId: any;
  isEnabled: Boolean = false;
  fromList: Boolean = false;
  maxLength = 4;
  assessment_name: any;
  candidateSuspiciousCount: any;
  candidateFaceViolationCount: any;
  candidateTimeSpentForAssessment: any;
  candidateName: any;
  suspicionReason: any;
  markBtnLabel: any = "Evaluate";
  candidateResponseDesc: any = [];
  emptyArray: any = [];
  formattedAns: any = [];
  statusLabel: any = "";
  reviewComment: any = "";
  remarkDetails: any = [];
  commentedBy: any = "";
  showCommentSecion: Boolean = false;
  showDescriptiveIcon: any;
  startTimeMap: any = "";
  endTimeMap: any = "";
  candidateIndex = 0;
  screenOptions = {
    position: 0,
  };
  onlinecompiler: boolean;
  onlinequestionCount: any;
  questionViewPreferences: string;
  getDoSelectEdit: any;
  onlineSection: any = [];
  onlinecomp: any;
  forOnlineCompiler: boolean = false;
  onlinetestNameDe: any;
  onlineSectionName: any;
  Psychometer: boolean = false;
  totalProblems: any;
  problemType: any;

  optionDetails: any = [];
  lhsArrDetails: any = [];
  rhsArrDetails: any = [];
  lhsMediaDetails: any = [];
  newlhsArrDetails: any;
  newrhsArrDetails: any;
  assignedTo: any = [];
  roleManagementError = "";
  hasDescriptiveQuestions: boolean = false;
  masterQBAccess: boolean = false;
  editFlag: boolean = true;
  showCenterManagerChkBx: boolean = true;
  searchText: string = "";
  searchText1: string = "";
  noDataFoundFlag: boolean = false;
  noCandidateFound: boolean = false;
  inviteErr: string = "";
  CandidateErr: string = "";
  appendAccessCodeFlag: boolean = false;
  dispPublicLinkCreation: any;

  evaluationStageList: any[] = [];
  isCreateNewStage: boolean = false;
  isAddMore: boolean = false;
  nameControl: FormControl;
  stageCreation: FormGroup;
  isStageEdit: boolean = false;
  editStageId: number;
  maxStageLimit: number = 5;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assessmentService: AssessmentService,
    private jobService: JobService,
    private toastrService: ToastrService,
    private _location: Location,
    // private listOfCan: ListOfCandidatesComponent,
    private ngxService: NgxUiLoaderService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private overlay: Overlay
  ) {
    this.accessToken = localStorage.getItem("accessToken");
    this.companyId = localStorage.getItem("companyId");
    this.companyType = localStorage.getItem("companyType");
    this.proctor = localStorage.getItem("proctor");
    this.getRouteParams();
    this.nameControl = this.fb.control("", Validators.required);

    this.stageCreation = this.fb.group({
      stageTitle: ["", Validators.required],
      evaluatorCandidateLimit: ["", Validators.required],
      isEdit: false,
    });
  }

  ngOnInit() {
    this.assementType();
    this.getLevelOfAssess();
    this.getQuestionType();
    this.getTagsForLink();
    localStorage.removeItem("hasDescriptiveQuestions");
    this.modalResetCandidate = new FormGroup({
      reset: new FormControl("", Validators.required),
      resetReason: new FormControl("", Validators.required),
    });
    if (localStorage.getItem("fromInviteComp") === "FromInviteComponent") {
      this.listofInvitationLink(true);
      if (localStorage.getItem("createdLinkId") !== null) {
        const linkId = localStorage.getItem("createdLinkId");
        const payload = { linkId: linkId };
        (async () => {
          try {
            const response: any = await lastValueFrom(
              this.assessmentService.candidatesLinkIDDetails(
                payload,
                this.companyId,
                this.accessToken
              )
            );
            this.ViewAccessCode(response.message, true);
          } catch (error) {
            this.errorMsg = error.error.message;
          }
        })();
      }
    }
    window.onbeforeunload = function () {
      localStorage.removeItem("fromInviteComp");
      return "";
    };
    this.userDetails = JSON.parse(localStorage.getItem("userInfo"));
    this.userRole = this.userDetails.Companies[0].RoleId;

    var qbAccess = localStorage.getItem("masterQBAccess");
    if (qbAccess == "allowed") {
      this.masterQBAccess = true;
    } else {
      this.masterQBAccess = false;
    }

    var assessmentType = localStorage.getItem("_assessmentType");
    if (assessmentType == "Aptitude" || assessmentType == "Psychometer") {
      if (!this.masterQBAccess) {
        this.editFlag = false;
      }
    } else {
      this.editFlag = true;
    }
    this.ngxService.stop();
  }

  ngOnDestroy() {
    localStorage.removeItem("fromInviteComp");
  }

  getRouteParams() {
    this.route.params.subscribe(
      (params) => {
        if (params.id) {
          this.getAssessmentDetails(params["id"]);
          this.createdassessmentId = params["id"];
        }
      },
      (error) => console.log(error)
    );
  }

  assessmentDashboard() {
    this.router.navigate(["assessment/list"]);
  }

  async getAssessmentDetails(id: any) {
    const payload = { assessmentId: id };
    try {
      const res: any = await lastValueFrom(
        this.assessmentService.getAssessmentById(
          payload,
          this.companyId,
          this.accessToken
        )
      );

      this.assessmentDetails = res.message[0];
      this.editId = this.assessmentDetails._id;
      this.assessmentTypeForLoadMore = this.assessmentDetails.assessmentType;
      localStorage.setItem(
        "assessmentTypeFromDetails",
        this.assessmentTypeForLoadMore
      );

      localStorage.setItem(
        "hasCodingQuestions",
        res.message[0].hasCodingQuestions
      );
      if (this.proctor === "proctor") {
        this.listofInvitationLink(true);
        this.candidatesLinkIDDetails();
      }
      this.assessmentSection = this.assessmentDetails.sections;
      this.onlinetestNameDe = this.assessmentDetails.onlineCompiler.testName;
      localStorage.setItem("SelectedonlinetestName", this.onlinetestNameDe);
      this.afterTestMessage = this.assessmentDetails.configuration.addMessage;
      this.afterTestMessageValue =
        this.assessmentDetails.configuration.addMessageValue;
      this.instructForTest =
        this.assessmentDetails.configuration.instructionForTest;
      this.instructForTestValue =
        this.assessmentDetails.configuration.instructionForTestValue;
      this.onlinequestionCount = this.assessmentDetails.questionCount;
      this.questionViewPreferences = this.assessmentDetails.sections.map(
        (section) => section.questionViewPreference
      );
      for (let i = 0; i < this.assessmentSection.length; i++) {
        let sum = 0;
        let questionTypeCounting = 0;
        for (let j = 0; j < this.assessmentSection[i].categories.length; j++) {
          if (this.assessmentSection[i].categories[j].questionType === null) {
            this.assessmentSection[i].categories[j].questionType = [];
          }
          if (
            this.assessmentSection[i].categories[j].questionType[0] ==
            "Descriptive"
          ) {
            localStorage.setItem("hasDescriptiveQuestions", "yes");
            this.hasDescriptiveQuestions = true;
          }
          sum += Number(
            this.assessmentSection[i].categories[j].numberOfQuestions
          );
          if (
            this.assessmentSection[i].categories[0].questionType[0] !==
            this.assessmentSection[i].categories[j].questionType[0]
          ) {
            questionTypeCounting += 1;
          }
        }
        this.QuestionType =
          this.assessmentSection[i].categories[0].questionType[0];
        this.assessmentNumQuestion[i] = sum;
        if (questionTypeCounting !== 0) {
          this.assessmentQuestionType[i] =
            "" + this.QuestionType + " +" + questionTypeCounting + " more";
        } else {
          this.assessmentQuestionType[i] = "" + this.QuestionType;
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async candidatesLinkIDDetails() {
    this.proctorLinkId = localStorage.getItem("linkedId");
    const payload = { linkId: this.proctorLinkId };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.candidatesLinkIDDetails(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.candidateReportList(response.message, true);
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  async sectionWiseQuestion(data, idx) {
    this.assessmentDescriptionDash = true;
    this.questionAnswerSave = [];
    this.showAssessemt = false;
    this.assessmentList1 = false;
    this.assessmentData = false;
    this.sectionIndex = idx;
    data.categories.forEach((ele) => {
      if (!ele.categoryId) {
        ele.categoryId = ele.parentCategoryId;
      }
    });

    if (localStorage.getItem("assessmentTypeFromDetails") === "Psychometer") {
      this.Psychometer = true;
    }

    if (
      localStorage.getItem("assessmentTypeFromDetails") === "Online Compiler"
    ) {
      this.forOnlineCompiler = true;

      try {
        const res: any = await lastValueFrom(
          this.assessmentService.getTest(this.companyId, this.accessToken)
        );
        this.getDoSelectEdit = res.message.objects;
        this.showSectionQuestion = true;
        this.asseementQuestion = false;
        let sampletest = [];
        for (let i = 0; i < this.getDoSelectEdit.length; i++) {
          if (
            this.getDoSelectEdit[i].name ==
            localStorage.getItem("SelectedonlinetestName")
          ) {
            sampletest.push(this.getDoSelectEdit[i]);
            this.onlineSection = sampletest[0].sections[0];
            this.onlineSectionName = sampletest[0].sections[0].name;
            this.totalProblems = sampletest[0].sections[0].num_problems;
            this.problemType =
              sampletest[0].sections[0].problems[0].problem_type;
          }
        }
      } catch (error) {
        console.log(error.error.message);
      }
    }
    const payload = { sections: [data] };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.sectionWiseQuestion(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.sectionWiseQuestionDetail = response;
      this.asseementQuestion = false;
      this.showSectionQuestion = true;
      if (response && response[0] && response[0].questions) {
        this.questionAnswer = response[0].questions;
        for (let i = 0; i < this.questionAnswer.length; i++) {
          if (this.questionAnswer[i].questionType !== "Reading Comprehension") {
            let obj = {};
            if (
              this.questionAnswer[i].questionType !== "Fill In The Blanks" &&
              this.questionAnswer[i].questionType !== "Descriptive" &&
              this.questionAnswer[i].questionType !== "Match The Following" &&
              this.questionAnswer[i].questionType !== "Coding"
            ) {
              if (
                this.questionAnswer[i].questionType == "MCQ - Single Answer"
              ) {
                this.questionAnswerSave[i] = this.questionAnswer[i].answer;
              }
              if (
                this.questionAnswer[i].questionType == "MCQ - Multiple Answers"
              ) {
                this.questionAnswerSave[i] =
                  this.questionAnswer[i].answer.split(",");
              }
              obj = {
                a: this.questionAnswerSave[i][0],
                b: this.questionAnswerSave[i][1],
                c: this.questionAnswerSave[i][2],
                d: this.questionAnswerSave[i][3],
              };

              this.questionAnswer[i].answer = obj;
            }

            // view for match the following
            if (this.questionAnswer[i].questionType === "Match The Following") {
              this.lhsArrDetails = this.questionAnswer[i].LHSOptions;
              this.rhsArrDetails = this.questionAnswer[i].RHSOptions;
              this.optionDetails = this.questionAnswer[i].answer;
              this.lhsMediaDetails = this.questionAnswer[i].LHSOptionsFiles;
              this.newlhsArrDetails = this.lhsArrDetails.map((it, index) => {
                let key = Object.keys(it);
                let firstKey = key[0];
                let tempAns = this.optionDetails[index];
                return Object.assign({
                  question: it[firstKey],
                  answer: tempAns,
                });
              });

              this.newrhsArrDetails = this.rhsArrDetails.map((it) => {
                let key = Object.keys(it);
                let firstKey = key[0];
                return Object.assign({ val: firstKey, name: it[firstKey] });
              });
            }

            if (
              this.questionAnswer[i].questionType === "Fill In The Blanks" &&
              Object.keys(this.questionAnswer[i].answer).length !== 0
            ) {
              let arr = [];
              const regex = /#blank#/gi;
              arr = this.questionAnswer[i].question.split(regex);
              arr = arr.map((part) => part.replace(/\n/g, "<br>"));
              Object.keys(this.questionAnswer[i].answer).forEach((key, j) => {
                if (this.questionAnswer[i].answer[key].length > 1) {
                  this.questionAnswer[i].answer[key] =
                    this.questionAnswer[i].answer[key].join(" / ");
                }
                arr[j] =
                  arr[j] +
                  '<span class="blank-ans">' +
                  this.questionAnswer[i].answer[key] +
                  ' <img alt="right-tick" src="/assets/img/Upload completed.png"> </span>';
              });
              this.questionAnswer[i].question = arr
                .join("")
                .split("?")
                .join(".");
            }
          } else {
            if (this.questionAnswer[i].subQuestions) {
              this.questionAnswer[i].subQuestions.forEach((question, i) => {
                const type = question.questionType;

                // Handle standard question types (not "Fill In The Blanks", "Descriptive", or "Match The Following")
                if (
                  type !== "Fill In The Blanks" &&
                  type !== "Descriptive" &&
                  type !== "Match The Following"
                ) {
                  // Split the answer string into an array
                  this.questionAnswerSave[i] = question.answer.split(",");

                  // Map the array values to an object with keys a, b, c, d
                  const obj = {
                    a: this.questionAnswerSave[i][0],
                    b: this.questionAnswerSave[i][1],
                    c: this.questionAnswerSave[i][2],
                    d: this.questionAnswerSave[i][3],
                  };

                  // Replace the original answer with the object
                  question.answer = obj;
                }

                // Handle "Fill In The Blanks" type
                if (
                  type === "Fill In The Blanks" &&
                  Object.keys(question.answer).length !== 0
                ) {
                  let tempArray = [];

                  tempArray = question.answer;

                  this.fillInTheBlanksQuesn = "";
                  this.fillInTheBlanksQuesn = question.question;
                  let arr = [];
                  arr = this.fillInTheBlanksQuesn.split(/#blank#/g);
                  arr = arr.map((part) => part.replace(/\n/g, "<br>"));
                  // Process each key-value pair in tempArray
                  Object.keys(tempArray).forEach((key, j) => {
                    const valueArray = tempArray[key].Value; // Access the Value array

                    if (valueArray.length > 1) {
                      tempArray[key].Value = valueArray.join(" / ");
                    } else {
                      tempArray[key].Value = valueArray[0]; // Single element in the array
                    }

                    arr[j] =
                      arr[j] +
                      `<span class="blank-ans">${tempArray[key].Value} <img alt="right-tick" src="/assets/img/Upload completed.png"></span>`;
                  });

                  this.fillInTheBlanksQuesn = arr.join("").split("?").join(".");
                }
              });
            }
          }
        }
      }
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  getOptionText(optionObj, optionType) {
    return myExtObject.getMTFOptionText(optionObj, optionType);
  }

  getOptionKey(optionObj, optionType) {
    return myExtObject.getMTFOptionKey(optionObj, optionType);
  }

  async getReviewDetails(data: any) {
    this.isReviewLoading = false;
    if (this.isReviewLoading) {
      return;
    }
    if (typeof data === "boolean") {
      this.fromList = data;
    }
    if (data === true) {
      this.reviewId =
        this.candidateReportResponse[
          this.candidateIndex
        ].candidateReviewAssessmentDetails[0].assessmentId;
      this.countryCode = this.countryCodeNum;
    } else {
      this.reviewId = data.candidateReviewAssessmentDetails[0].assessmentId;
      this.mobileNum = data.mobile;
      this.countryCode = data.countryCode;
    }
    const payload = {
      assessmentId: this.reviewId,
      linkId: this.addLinkID,
      mobile: this.mobileNum,
      countryCode: this.countryCode,
    };
    this.reviewDetails = [];
    this.descriptiveMarks = [];
    this.emptyArray = [];
    this.remarkDetails = [];
    this.commentedBy = "";
    this.reviewComment = "";
    if (this.reviewId !== "") {
      try {
        const response: any = await lastValueFrom(
          this.assessmentService.getDescriptiveQuestions(
            payload,
            this.companyId,
            this.accessToken
          )
        );
        if (response.descriptiveQuestions !== null) {
          if (response.remarkedDetails && response.remarkedDetails.length > 0) {
            this.remarkDetails = response.remarkedDetails;
            this.remarkDetails = this.remarkDetails.reverse();
            this.commentedBy = response.remarkedBy;
          }

          this.reviewDetails = response.descriptiveQuestions;
          this.formatAnswer(this.reviewDetails);

          this.reviewDetails.forEach((val, j) => {
            if (val.answer === "") {
              this.descriptiveMarks[j] = {
                questionId: val.questionId,
                marks: val.adminScore,
              };

              this.emptyArray.push(val);
            } else {
              this.descriptiveMarks[j] = {
                questionId: val.questionId,
                marks: val.adminScore,
              };
              if (val.adminScore >= 0) {
                this.descriptiveMarks[j] = {
                  questionId: val.questionId,
                  marks: val.adminScore,
                };
              }
              if (val.adminScore === "") {
                this.isEnabled = true;
              }
            }
          });

          this.checkForLabel(this.mobileNum);
          $("#reviewModal").modal("show");
          this.isReviewLoading = true;
        } else {
          $("#reviewModal").modal("hide");
        }
      } catch (error) {
        this.errorMsg = error.error.message;
        $("#reviewModal").modal("hide");
      }
    }
  }

  formatAnswer(data) {
    this.formattedAns = [];
    if (data !== undefined) {
      data.forEach((str) => {
        if (str.answer !== null) {
          const formatStr = str.answer
            .split("\n")
            .join("<br>")
            .split(" ")
            .join("&nbsp;");
          this.formattedAns.push(formatStr);
        }
      });
    }
  }

  marksScored(e, idx) {
    if (e.target.value !== "" && e.target.value !== " ") {
      this.descriptiveMarks[idx]["marks"] = e.target.value;
    }
  }

  validateNumber(e, idx) {
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && e.keyCode < 96) ||
      (e.keyCode !== 190 && e.keyCode > 105) ||
      (e.keyCode > 105 && e.shiftKey)
    ) {
      e.preventDefault();
    }
  }

  restrictMax(e, idx) {
    const num = e.target.value.split(".");
    if (num[0] === "") {
      this.maxLength = 3;
    } else if (num[0].length > 1) {
      this.maxLength = 5;
    } else {
      this.maxLength = 4;
    }
    if (e.target.value === "") {
      this.isEnabled = true;
    } else {
      this.isEnabled = false;
      this.checkForEmpty();
    }

    if (e.target.value > Number(this.reviewDetails[idx].questionScore)) {
      e.target.value = "";
      this.descriptiveMarks[idx]["marks"] = "";
      this.isEnabled = true;
      this.checkForEmpty();
    }
  }

  checkForEmpty() {
    this.descriptiveMarks.forEach((val, k) => {
      if (this.reviewDetails[k].answer !== "" && val.marks === "") {
        this.isEnabled = true;
      }
    });
  }

  async publishResult() {
    this.isReviewLoading = false;
    if (this.isReviewLoading) {
      return;
    }
    const payload = {
      linkId: this.addLinkID,
      mobile: this.mobileNum,
      countryCode: this.countryCode,
      assessmentId: this.reviewId,
      adminScore: this.descriptiveMarks,
      isMarkAsEvaluated: true,
      status: this.statusLabel,
      remark: this.reviewComment,
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.saveDescriptiveScore(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      $("#reviewModal").modal("hide");
      this.toastrService.success(response.Response);
      this.isReviewLoading = true;
      if (!this.fromList) {
        this.candidateReportList(this.linkData, true);
      }
      this.reviewComment = "";
    } catch (error) {
      this.errorMsg = error.error.message;
      $("#reviewModal").modal("hide");
      this.reviewComment = "";
    }
  }

  reviewCancel() {
    $("#reviewModal").modal("hide");
    this.descriptiveMarks = [];
    this.reviewDetails = [];
  }

  sectionDetails() {
    window.scroll(0, 0);
    if (document.getElementById("Question") != null) {
      document.getElementById("Question").style.color = "#0ec2d0";
      document.getElementById("invites").style.color = "";
      document.getElementById("Details").style.color = "";
      document.getElementById("config").style.color = "";
      document.getElementById("Details").style.borderBottom = "";
      document.getElementById("invites").style.borderBottom = "";
      document.getElementById("Question").style.borderBottom = "2px solid";
      document.getElementById("config").style.borderBottom = "";
    }
    this.assessmentDescriptionDash = true;
    this.assessmentData = false;
    this.assessmentCandidatesDetails = false;
    this.CandidateReportDetails = false;
    this.showAssessemt = false;
    this.assessmentList1 = false;
    this.asseementQuestion = true;
    this.showSectionQuestion = false;
    this.assessmentConfigurationDash = false;
    this.assessmentListOfCandidates = false;
    localStorage.removeItem("fromInviteComp");
  }

  assessmentDetailsHeader() {
    window.scroll(0, 0);
    if (document.getElementById("Details") != null) {
      document.getElementById("Details").style.color = "#0ec2d0";
      document.getElementById("invites").style.color = "";
      document.getElementById("Question").style.color = "";
      document.getElementById("config").style.color = "";
      document.getElementById("Details").style.borderBottom = "2px solid";
      document.getElementById("invites").style.borderBottom = "";
      document.getElementById("Question").style.borderBottom = "";
      document.getElementById("config").style.borderBottom = "";
    }
    this.assessmentDescriptionDash = true;
    this.assessmentCandidatesDetails = false;
    this.CandidateReportDetails = false;
    this.showAssessemt = false;
    this.assessmentList1 = false;
    this.assessmentData = true;
    this.asseementQuestion = false;
    this.showSectionQuestion = false;
    this.assessmentConfigurationDash = false;
    this.assessmentListOfCandidates = false;
    localStorage.removeItem("fromInviteComp");
  }

  aseessmentConfigHeader() {
    window.scroll(0, 0);
    if (document.getElementById("config") != null) {
      document.getElementById("config").style.color = "#0ec2d0";
      document.getElementById("invites").style.color = "";
      document.getElementById("Details").style.color = "";
      document.getElementById("Question").style.color = "";
      document.getElementById("Details").style.borderBottom = "";
      document.getElementById("invites").style.borderBottom = "";
      document.getElementById("Question").style.borderBottom = "";
      document.getElementById("config").style.borderBottom = "2px solid";
    }
    this.assessmentDescriptionDash = true;
    this.assessmentCandidatesDetails = false;
    this.showAssessemt = false;
    this.assessmentList1 = false;
    this.assessmentData = false;
    this.asseementQuestion = false;
    this.showSectionQuestion = false;
    this.assessmentListOfCandidates = false;
    this.CandidateReportDetails = false;
    this.assessmentConfigurationDash = true;
    localStorage.removeItem("fromInviteComp");
  }

  async listofInvitationLink(
    check,
    searchFlag?: boolean,
    stayOnPage: boolean = false
  ) {
    this.ngxService.start();
    if (!(searchFlag === undefined)) {
      this.searchFlag = searchFlag;
    }

    // to reset the  value of search and search tags in both invite list and candidate list
    if (!this.searchFlag) {
      this.searchText = "";
      this.searchText1 = "";
      this.searchTextTag = "";
      this.candidateSearchText = "";
      this.candidateSearchText1 = "";
      this.candidateSearchTextTag = "";
      this.assessmentService.setCandidateSearchText(this.candidateSearchText);
    }
    //***************************************************/

    if (this.isRequestInProcess) {
      return;
    }
    if (check === false) {
      this.skipforLinkList++;
    } else {
      this.skipforLinkList = 0;
      this.listofLinkDetails = [];
    }
    if (localStorage.getItem("fromInviteComp") === "FromInviteComponent") {
      setTimeout(() => {
        if (document.getElementById("invites") != null) {
          document.getElementById("Details").style.color = "";
          document.getElementById("Details").style.borderBottom = "";
          document.getElementById("invites").style.color = "#0ec2d0";
          document.getElementById("invites").style.borderBottom = "2px solid";
        }
      }, 2000);
    }
    if (document.getElementById("invites") != null) {
      document.getElementById("invites").style.color = "#0ec2d0";
      document.getElementById("invites").style.borderBottom = "2px solid";
      document.getElementById("Details").style.color = "";
      document.getElementById("Details").style.borderBottom = "";
      document.getElementById("Question").style.color = "";
      document.getElementById("config").style.color = "";
      document.getElementById("Question").style.borderBottom = "";
      document.getElementById("config").style.borderBottom = "";
    }
    if (!stayOnPage) {
      this.assessmentDescriptionDash = true;
      this.assessmentCandidatesDetails = false;
      this.CandidateReportDetails = false;
      this.assessmentData = false;
      this.showAssessemt = false;
      this.assessmentList1 = false;
      this.asseementQuestion = false;
      this.showSectionQuestion = false;
      this.assessmentConfigurationDash = false;
      this.assessmentListOfCandidates = true;
    }
    const payload = {
      referenceId: this.createdassessmentId,
      searchText: this.searchText,
    };
    this.isRequestInProcess = true;

    return new Promise(async (resolve, reject) => {
      try {
        const response: any = await lastValueFrom(
          this.assessmentService.listofInvitationLink(
            payload,
            this.companyId,
            this.accessToken,
            this.skipforLinkList
          )
        );

        this.isRequestInProcess = false;

        this.listOfLinkForAssessment = response.isMoreList;
        let listofLink = [];
        listofLink = response.message;

        localStorage.setItem("IsDescriptive", listofLink[0].isDescriptive);
        this.listofLinkDetails = this.listofLinkDetails.concat(listofLink);

        this.publicLinkcreateion = response.linkUrl;
        this.listMessage = true;
        // this.skipforLinkList++;
        this.listErrMessage = false;
        this.selectInviteSection();
        this.ngxService.stop();
        resolve(response);
      } catch (error) {
        this.ngxService.stop();
        this.listofLinkDetails = [];
        this.isRequestInProcess = false;
        this.errorMsg = error.error.message;

        if (
          error.error["message"] === "No matching batch found" &&
          this.searchText != ""
        ) {
          this.noDataFoundFlag = true;
          // this.assessmentNumber=0;
          this.listOfLinkForAssessment = false;
          // this.totalCount=''
          this.inviteErr = error.error.message;
          resolve(null);
          return;
        } else if (
          error.error["message"] ===
            "Text should not be less than 3 characters." &&
          this.searchText != ""
        ) {
          this.lessChar = true;
          // this.assessmentNumber=0;
          this.listOfLinkForAssessment = false;
          // this.totalCount=''
          resolve(null);
          return;
        } else {
          this.listMessage = false;
          this.listErrMessage = true;
        }
        resolve(null);
      }
    });
  }

  async refreshDataAfterEvaluation() {
    await this.listofInvitationLink(true, false, true);
    if (this.linkData && this.linkData._id) {
      let dataToUse = this.linkData;
      const updatedLinkData = this.listofLinkDetails.find(
        (link) => link._id === this.linkData._id
      );
      if (updatedLinkData) {
        dataToUse = updatedLinkData;
      }
      this.candidateReportList(dataToUse, true);
    }
  }

  resetSearch() {
    this.searchTextTag = "";
    this.searchText = "";
    this.listofLinkDetails = [];
    this.listofInvitationLink(true);
    this.noDataFoundFlag = false;
    this.lessChar = false;
    this.searchFlag = false;
  }

  async resetCandidateSearch() {
    this.candidateSearchTextTag = "";
    this.candidateSearchText = "";
    this.candidateReportResponse = [];
    this.candidateSearchText1 = "";
    // this.assessmentService.setCandidateSearchText(this.candidateSearchText);

    // await this.candidateReportList(this.linkData, true);
    this.noDataFoundFlag = false;
    this.searchFlag = false;
    // this.listOfCan.ngOnInit();
  }

  copyLink() {
    const copyText = document.getElementById("linkGener") as HTMLInputElement;
    copyText.select();
    document.execCommand("copy");
  }

  selectInviteSection() {
    if (document.getElementById("invites") != null) {
      document.getElementById("invites").style.color = "#0ec2d0";
      document.getElementById("Details").style.color = "";
      document.getElementById("Question").style.color = "";
      document.getElementById("config").style.color = "";
      document.getElementById("Details").style.borderBottom = "";
      document.getElementById("invites").style.borderBottom = "2px solid";
      document.getElementById("Question").style.borderBottom = "";
      document.getElementById("config").style.borderBottom = "";
    }
  }

  listAssessment(assType) {
    const type = assType.toLowerCase();
    this.router.navigate(["assessment/list/" + type]);
  }

  async assementType() {
    const payload = {
      type: "assessmentType",
      assessmentType: "",
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.getLevelOfAssess(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.assessmentTypeList = response;
    } catch (error) {
      console.log(error.error.message);
    }
  }

  async getLevelOfAssess() {
    const payload = {
      type: "level",
      assessmentType: "",
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.getLevelOfAssess(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.levelOfQuestion = response;
    } catch (error) {
      console.log(error.error.message);
    }
  }

  async getTagsForLink() {
    const payload = {
      type: "tagsForLink",
      assessmentType: "",
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.getLevelOfAssess(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.tagsForLink = response;
    } catch (error) {
      console.log(error.error.message);
    }
  }

  async getQuestionType() {
    const payload = {
      type: "questionType",
      assessmentType: "",
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.getLevelOfAssess(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.typeOfQuestion = response;
    } catch (error) {
      // console.log(error.error.message);
    }
  }

  editAssessment(id: any) {
    if (this.assessmentDetails.quickAssessmentTemplateId) {
      this.router.navigate(["assessment/update-quick-assessment/" + id]);
    } else {
      this.router.navigate(["assessment/update/" + id]);
    }
  }

  backLocation() {
    this._location.back();
  }

  deleteAssessment(assId: any, check) {
    $("#deleteSingleAssessmentData").modal("show");
    this.assessmentIdDelete = assId;
  }

  async deleteAssessmentDATA(check) {
    const payload = { arrayData: [this.assessmentIdDelete] };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.assessmentDelete(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.assessmentDescriptionDash = false;
      this.assessmentIdDelete = "";
      this.router.navigate(["/assessment/list"]);
      if (check === true) {
        this.toastrService.success("Assessment deleted successfully", "", {
          timeOut: 5000,
        });
      } else {
        this.toastrService.success("Assessment archived successfully", "", {
          timeOut: 5000,
        });
      }
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  addPreviewCandidates() {
    this.router.navigate([
      "assessment/publish-link/" + this.createdassessmentId,
    ]);
    localStorage.setItem("isAddCandidate", "AddNewCandidate");
  }

  async downloadLocation() {
    const payload = { linkId: this.CandidatelinkID };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.exportCandidateExcel(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.candidateLocation = response.location;
      localStorage.setItem("location", "this.candidateLocation");
      window.open(this.candidateLocation, "_blank");
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  searchBatch() {
    if (!this.searchText1.replace(/\s/g, "").length) {
      this.searchText1 = "";
      return;
    }
    if (
      this.searchText1.charAt(0) == " " ||
      this.searchText1.charAt(this.searchText1.length - 1) == " "
    ) {
      this.searchText1 = this.searchText1.trim();
    }
    if (this.searchText1.length < 3) {
      return;
    }

    this.searchText = this.searchText1;
    this.searchTextTag = this.searchText;
    this.searchFlag = true;
    this.noDataFoundFlag = false;

    this.listofInvitationLink(true);
    this.lessChar = false;
    this.searchText1 = "";
  }

  noInvitaionForAssesment() {
    this.router.navigate([
      "assessment/publish-link/" + this.createdassessmentId,
    ]);
  }

  openMedia(url: string, type: string) {
    this.selectedMediaUrl = url;
    this.selectedMediaType = type;
    this.myVideo.nativeElement.pause();
  }

  closeModal() {
    this.selectedMediaUrl = null;
    this.selectedMediaType = null;
  }

  createNewAssessment() {
    var assessmentType = localStorage.getItem("_assessmentType");

    if (assessmentType == "Aptitude" || assessmentType == "Psychometer") {
      if (!this.masterQBAccess) {
        $("#AccessDenied").modal("show");
      } else {
        this.router.navigate(["assessment/create"]);
      }
    } else if (
      assessmentType == "Role Based" ||
      assessmentType == "Skill Based" ||
      assessmentType == "POSH"
    ) {
      this.router.navigate(["/skill-based-assessment"]);
    } else {
      // localStorage.setItem("_assessmentType", params.type);
      this.router.navigate(["assessment/create"]);
    }

    // this.router.navigate(['assessment/create/']);
  }

  async testCodeGeneration() {
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.testCodeGenerate(
          this.companyId,
          this.accessToken
        )
      );
      console.log(response.message);
      this.Testcode = response.message;
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  ViewAccessCode(data, flag: boolean) {
    this.appendAccessCodeFlag = flag;
    this.Testcode = data.testCode;
    this.dispPublicLinkCreation =
      this.publicLinkcreateion + "&batchtoken=" + this.Testcode;

    if (localStorage.getItem("createdLinkId") !== null) {
      $("#publicLink").modal("show");
    }
    $("#publicLink").modal("show");

    // this.listofInvitationLink(true);
    localStorage.removeItem("createdLinkId");
  }

  deleteLink(linkID) {
    $("#deleteLink").modal("show");
    this.linkIdDeleted = linkID;
  }

  async deleteLinkMessage() {
    const payload = { linkId: this.linkIdDeleted };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.deleteLink(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.listofInvitationLink(true);
      this.toastrService.success("Link archived successfully", "", {
        timeOut: 5000,
      });
      this.linkIdDeleted = "";
    } catch (error) {
      this.errorMsg = error.error.message;
    }
  }

  checkForLabel(mobile: any) {
    this.candidateResponseDesc.forEach(
      (val: { mobile: any; candidateReviewAssessmentDetails: any[] }) => {
        if (
          mobile === val.mobile &&
          val.candidateReviewAssessmentDetails != null
        ) {
          val.candidateReviewAssessmentDetails.forEach((review) => {
            if (this.reviewDetails.length === this.emptyArray.length) {
              this.markBtnLabel = "Mark As Evaluated";
              this.statusLabel = "";
              this.showCommentSecion = false;
              if (review.isReviewAnswer === "false") {
                this.isEnabled = true;
              } else {
                this.isEnabled = false;
              }
            } else if (review.isReviewAnswer === "true") {
              this.markBtnLabel = "Evaluate";
              this.statusLabel = "";
              this.showCommentSecion = false;
              this.isEnabled = false;
              this.checkForEmpty();
            } else {
              this.markBtnLabel = "Re-Evaluate";
              this.statusLabel = "Re-Evaluate";
              this.showCommentSecion = true;
              this.isEnabled = true;
            }
          });
        }
      }
    );
  }

  loadMoreCandidates() {
    this.candidateReportList(this.linkData, false);
  }

  async candidateReportList(data, check) {
    // this.listOfCan.isFetchingCandidateList=true;
    // this.listOfCan.ngOnInit();
    this.ngxService.start();
    this.linkData = data;

    this.assessmentService.setConfigurationData(data.configuration);
    if (this.isRequestInProcess) {
      return;
    }
    this.candidateListValue = data;
    this.CandidatelinkName = data.linkName;
    this.CandidatelinkID = data._id;
    this.addLinkID = data._id;
    this.CandidatelinkType = data.linkType;
    this.CandidateTrackLocation = data.configuration.trackGeoLocation;
    this.CandidateSnap = data.configuration.captureCandidateSnapshot;
    this.CandidateStartDT = data.configuration.startDate;
    this.CandidateEndDT = data.configuration.endDate;

    this.assessmentService.setLinkId(this.CandidatelinkID);

    if (check === false) {
      this.skipforCan++;
    } else {
      this.skipforCan = 0;
      this.candidateReportResponse = [];
      if (this.listOfCandidatesComponent) {
        this.listOfCandidatesComponent.batchCandidatePageNo = 0;
      }
    }

    const payload = {
      linkId: this.CandidatelinkID,
      searchText: this.candidateSearchText,
    };
    this.isRequestInProcess = true;
    if (this.CandidatelinkType === "PRIVATE") {
      localStorage.setItem("isAddLinkId", this.addLinkID);
    }
    this.candidateResponseDesc = [];
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.candidateReport(
          payload,
          this.skipforCan,
          this.companyId,
          this.accessToken
        )
      );

      this.isRequestInProcess = false;
      this.showCandidatelinkName = true;
      this.noCandidateFound = false;
      this.candidateResponseDesc = response.results;

      this.checkForLabel(this.mobileNum);
      this.candidateLocation = response.location;
      this.candidateListForLink = response.isMoreCandidates;

      localStorage.setItem("location", "this.candidateLocation");
      let listofcan = [];
      listofcan = response.results;

      await this.assessmentService.setBatchData(response);
      this.candidateReportResponse =
        this.candidateReportResponse.concat(listofcan);
      this.assessmentListOfCandidates = false;
      this.assessmentCandidatesDetails = true;
      this.CandidateReportDetails = false;
      this.assessmentData = false;
      this.showAssessemt = false;
      this.assessmentList1 = false;
      this.asseementQuestion = false;
      this.showSectionQuestion = false;
      this.assessmentConfigurationDash = false;
      this.privateLinkCreationStep1 = false;
      this.privateLinkCreationStep2 = false;
      this.publicLinkCreation = false;
      this.ngxService.stop();
    } catch (error) {
      this.ngxService.stop();
      this.isRequestInProcess = false;
      this.toastrService.info("No candidate found under the selected batch.");
      this.noCandidateFound = true;
      this.assessmentService.setBatchData(null);
      this.candidateListForLink = false;
      this.CandidateErr = error.error.message;
    }
  }

  candidateSnapcaptured(data) {
    this.trackGeoLocation = data[0].assessmentVersions[0].trackGeo;
    const startLat = parseFloat(
      data[0].assessmentVersions[0].trackGeo.startLocation.latitude
    );
    const startLng = parseFloat(
      data[0].assessmentVersions[0].trackGeo.startLocation.longitude
    );
    myExtObject.initMap3(startLat, startLng);
    $("#popUp").modal("show");
  }

  validateTime(e) {
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  }

  showLocation(data) {
    this.startTimeMap = data[0].assessmentVersions[0].appearedOn;
    this.endTimeMap = data[0].assessmentVersions[0].endedOn;
    this.trackGeoLocation = data[0].assessmentVersions[0].trackGeo;
    const startLat = parseFloat(
      data[0].assessmentVersions[0].trackGeo.startLocation.latitude
    );
    const startLng = parseFloat(
      data[0].assessmentVersions[0].trackGeo.startLocation.longitude
    );
    const endLat = parseFloat(
      data[0].assessmentVersions[0].trackGeo.endLocation.latitude
    );
    const endLng = parseFloat(
      data[0].assessmentVersions[0].trackGeo.endLocation.longitude
    );
    myExtObject.initMap1(startLat, startLng);
    myExtObject.initMap2(endLat, endLng);
    $("#candidatesLocation").modal("show");
  }

  redirectUrl(data) {
    if (data !== "") {
      window.open(data);
    } else {
    }
  }

  backButtonForLink() {
    this.fromList = false;
    this.candidateSearchText = "";
    this.candidateSearchText1 = "";
    this.candidateSearchTextTag = "";
    if (this.assessmentCandidatesDetails) {
      this.assessmentCandidatesDetails = false;
      this.assessmentListOfCandidates = true;
    }
    if (this.CandidateReportDetails) {
      this.CandidateReportDetails = false;
      this.assessmentCandidatesDetails = true;
    }
  }

  editLink(data) {
    localStorage.setItem(
      "_createdassessmentType",
      data.assessments[0].assessmentType
    );
    // CAL-1681, Job scenario is not considered
    localStorage.setItem("_isEditLink", "true");

    // CAL-1585, impact : Edit Public Link | If not set to 'true', different 'Access Code' get displayed in the screen.
    this.router.navigate(["assessment/editlink/" + data["_id"]]);
  }

  resetDateTimeScheduling() {
    this.publicerrorMsg = "";
    this.publicStartTime = "";
    this.publicSTARTDate = "";
    this.publicENDDate = "";
    this.publicEndTime = "";
    $("#startTime").val("");
    $("#endTime").val("");
  }

  CandidateResetTest() {
    $("#candidateReset").modal("show");
  }

  async CandidateRRReson(modal: any) {
    this.publicerrorMsg = "";
    const payload = {
      linkId: this.CandidatelinkID,
      mobile: this.mobileNum,
      countryCode: this.countryCodeNum,
      status: modal.reset,
      assessmentId: this.createdassessmentId,
      reason: modal.resetReason,
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.CandidateRRReson(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.modalResetCandidate.reset();
      $("#candidateReset").modal("hide");
      this.toastrService.success(response.message, "", {
        timeOut: 5000,
      });
    } catch (error) {
      this.publicerrorMsg = error.error.message;
    }
  }

  async cadidatesReports(data, status, idx) {
    if (status === "Not Taken" || status === "Expired") {
      return;
    }
    this.fromList = true;
    this.candidateIndex = idx;
    this.CandidateData = data;
    this.candidateName = data.candidateName;
    this.candidateAttendanceSnapshot = "";
    this.mobileNum = data.mobile;
    this.countryCodeNum = data.countryCode;
    if (this.candidateReportResponse.length > 0) {
      this.showDescriptiveIcon =
        this.candidateReportResponse[idx].candidateReviewAssessmentDetails[0];
    }
    const payload = {
      linkId: this.CandidatelinkID,
      mobile: this.mobileNum,
      countryCode: this.countryCodeNum,
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.cadidatesReports(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.CandidateReportData = response.results;

      const len = this.CandidateReportData[0].assessmentVersions.length;
      this.candidateAttendanceSnapshot =
        this.CandidateReportData[0].assessmentVersions[
          len - 1
        ].attendanceSnapshot;
      if (
        this.CandidateReportData[0].assessmentVersions[len - 1]
          .candidateSnapShot == null
      ) {
        this.candidateCaputerdSnapshot = [];
      } else {
        this.candidateCaputerdSnapshot =
          this.CandidateReportData[0].assessmentVersions[
            len - 1
          ].candidateSnapShot;
      }
      this.assessment_name = this.CandidateReportData[0].assessmentName;
      this.candidateSuspiciousCount =
        this.CandidateReportData[0].assessmentVersions[0].suspiciousCount;
      this.candidateFaceViolationCount =
        this.CandidateReportData[0].assessmentVersions[0].faceViolationCount;
      this.candidateTimeSpentForAssessment =
        this.CandidateReportData[0].assessmentVersions[0].totalTimeSpentForAssessment;
      this.assessmentCandidatesDetails = false;
      this.CandidateReportDetails = true;
      this.assessmentDescriptionDash = true;
      this.assessmentData = false;
      this.showAssessemt = false;
      this.assessmentList1 = false;
      this.asseementQuestion = false;
      this.showSectionQuestion = false;
      this.assessmentConfigurationDash = false;
      this.privateLinkCreationStep1 = false;
      this.privateLinkCreationStep2 = false;
      this.publicLinkCreation = false;
    } catch (error) {
      this.errorMsg = error.error.message;
      this.CandidateReportDetails = false;
    }
  }

  async bulkReportDownload() {
    const payload = {
      linkId: this.CandidatelinkID,
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.bulkReportData(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      // window.open(response.s3Location, '_blank');
      window.location = response.s3Location;
    } catch (error) {
      let errorMsg = "";
      if (error.status === 500) {
        errorMsg =
          "Unable to process the request at this moment. Please try again later.";
      } else {
        errorMsg = error.error.message;
      }
      this.toastrService.error(errorMsg, "Error", {
        timeOut: 5000,
      });
    }
  }

  getBatchAssignmentConfirmation() {
    let selectedEvaluatorNames = [];
    if (selectedEvaluatorNames.length == 1) {
      this.assignEvaluatorConfirmationMessage =
        selectedEvaluatorNames[0] +
        " will be added as evaluator in " +
        this.selectedBatch.linkName +
        ". \nDo you want to continue?";
    } else {
      this.assignEvaluatorConfirmationMessage =
        selectedEvaluatorNames.join(", ") +
        " will be added as evaluators in " +
        this.selectedBatch.linkName +
        ". \nDo you want to continue?";
    }

    $("#assignedPersonalModal").modal("hide");
    $("#confirmationEvaluator").modal("show");
  }

  confirmActionAssigneeRemoval(removalType: string, assigneeRecord: any) {
    this.removeAssigneeActionType = removalType;
    $("#assignedPersonalModal").modal("hide");
    this.selectedAssigneeDetails = assigneeRecord;
    if (removalType == "all") {
      this.unlinkAssigneeConfirmationMessage =
        "Sure!! Do you want to unlink all assignees from " +
        this.selectedBatch.linkName +
        "?";
    } else if (removalType == "individual") {
      this.unlinkAssigneeConfirmationMessage =
        "Sure!! Do you want to unlink " +
        this.selectedAssigneeDetails.userName +
        " from " +
        this.selectedBatch.linkName +
        "?";
    } else {
      return;
    }
    $("#confirmAssigneeRemoval").modal("show");
    this.showCenterManagerChkBx = true;
  }

  cancelUnlinking() {
    $("#confirmAssigneeRemoval").modal("hide");
  }

  async fetchAvailableAdministrators() {
    const payload = {
      linkId: this.selectedBatch._id,
    };

    try {
      const response: any = await lastValueFrom(
        this.assessmentService.availableAssigneeList(
          payload,
          this.accessToken,
          this.companyId
        )
      );
      let availableAssignees = response.user_list;
      if (availableAssignees.length == 0) {
        this.availableAssignees = [];
      } else {
        this.availableAssignees = [];
        this.selAssigneeId = "";
        this.assigneeRole.evaluate = false;
        this.assigneeRole.proctor = false;
        this.assigneeRole.centerManager = false;
        this.hideSelectAssigneeOption = false;
        for (
          let assigneeIndex = 0;
          assigneeIndex < availableAssignees.length;
          assigneeIndex++
        ) {
          this.availableAssignees.push({
            assigneeId: availableAssignees[assigneeIndex]._id,
            assigneeName:
              availableAssignees[assigneeIndex].firstName +
              " " +
              availableAssignees[assigneeIndex].lastName,
          });
        }
      }
      $("#manageAssigneePrivilegeModal").modal("show");
    } catch (error) {
      console.log(error);
    }
  }

  showAssignedPersonalsModal() {
    $("#manageAssigneePrivilegeModal").modal("hide");
    this.showAssignedPersonals(this.selectedBatch);
  }
  showAssignedPersonals(linkDetails) {
    console.log("linkDetails", linkDetails.isDescriptive);

    this.selectedBatch = linkDetails;
    this.batchReferenceId = linkDetails._id;

    this.assignedTo = linkDetails.assignedTo;

    if (linkDetails.isDescriptive) {
      this.getEvaluationBatchConf2();
    }

    // $('#ckhEvaluator').prop('checked', this.assignedTo.role.evaluate);
    // $('#chkProctor').prop('checked', this.assignedTo.role.proctor);
    // $('#chkCenterMngr').prop('checked',this.assignedTo.role.centerManager);
    this.removeAssigneeActionType = "";
    $("#assignedPersonalModal").modal("show");
    if (this.selectedBatch.configuration.enableLockUnlock) {
      for (var i = 0; i < this.selectedBatch.assignedTo.length; i++) {
        if (this.selectedBatch.assignedTo[i].role.centerManager) {
          this.showCenterManagerChkBx = false;
          break;
        } else {
          this.showCenterManagerChkBx = true;
        }
      }
    } else {
      this.showCenterManagerChkBx = false;
    }
  }

  async assignEvaluator() {
    if (this.selAssigneeId == "") {
      this.roleManagementError = "Select an assignee first";
      return;
    }
    if (
      this.assigneeRole.evaluate == false &&
      this.assigneeRole.proctor == false &&
      this.assigneeRole.centerManager == false
    ) {
      this.roleManagementError =
        "Set at least one role for the selected assignee";
      return;
    }
    this.roleManagementError = "";
    if (!this.hasDescriptiveQuestions) {
      this.assigneeRole.evaluate = false;
    }
    const payload = {
      batchReference: this.batchReferenceId,
      userReferences: this.selAssigneeId,
      role: this.assigneeRole,
    };
    try {
      const response: any = await lastValueFrom(
        this.assessmentService.assignRoleToAssignee(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      $("#manageAssigneePrivilegeModal").modal("hide");

      this.listofInvitationLink(true);
      this.toastrService.success(response.message, "", {
        timeOut: 5000,
      });
    } catch (error) {
      let errorMsg = "";
      if (error.status === 500) {
        errorMsg =
          "Unable to process the request at this moment. Please try again later.";
      } else {
        errorMsg = error.error.message;
      }
      this.toastrService.error(errorMsg, "Error", {
        timeOut: 5000,
      });
    }
  }
  clearDataEval() {
    this.editRowId = null;
    $("#assignedPersonalModal").modal("hide");
  }

  async executeUnlinkingAction() {
    const payload = {
      batchReference: this.batchReferenceId,
      userReference:
        this.removeAssigneeActionType == "individual"
          ? this.selectedAssigneeDetails.userId
          : "",
      removalType: this.removeAssigneeActionType,
    };

    try {
      const response: any = await lastValueFrom(
        this.assessmentService.unLinkAssignee(
          payload,
          this.companyId,
          this.accessToken
        )
      );
      this.listofInvitationLink(true);
      this.toastrService.success(response.message, "", {
        timeOut: 5000,
      });
    } catch (error) {
      let errorMsg = "";
      if (error.status === 500) {
        errorMsg =
          "Unable to process the request at this moment. Please try again later.";
      } else {
        errorMsg = error.error.message;
      }
      this.toastrService.error(errorMsg, "Error", {
        timeOut: 5000,
      });
    }
  }

  manageAssigneePrivileges() {
    $("#assignedPersonalModal").modal("hide");
    this.fetchAvailableAdministrators();
  }

  initiateAssigneePrivilegeEdit(selAssignee: any) {
    $("#assignedPersonalModal").modal("hide");
    this.availableAssignees = [];
    this.availableAssignees.push({
      assigneeId: selAssignee.userId,
      assigneeName: selAssignee.userName,
    });
    this.selAssigneeId = selAssignee.userId;
    this.assigneeRole.evaluate = selAssignee.role.evaluate;
    this.assigneeRole.proctor = selAssignee.role.proctor;
    this.assigneeRole.centerManager = selAssignee.role.centerManager;

    if (this.assigneeRole.centerManager) {
      this.showCenterManagerChkBx = true;
    }
    this.hideSelectAssigneeOption = true;
    $("#manageAssigneePrivilegeModal").modal("show");
  }

  setAssigneeRole($event: Event, role: string) {
    this.roleManagementError = "";
    if (role == "Evaluator") {
      if ((<HTMLInputElement>$event.target).checked) {
        this.assigneeRole.evaluate = true;
      } else {
        this.assigneeRole.evaluate = false;
      }
    } else if (role == "Proctor") {
      if ((<HTMLInputElement>$event.target).checked) {
        this.assigneeRole.proctor = true;
      } else {
        this.assigneeRole.proctor = false;
      }
    } else if (role == "CenterManager") {
      if ((<HTMLInputElement>$event.target).checked) {
        this.assigneeRole.centerManager = true;
      } else {
        this.assigneeRole.centerManager = false;
      }
    } else {
      return;
    }
  }

  changeBreadCrumb(value: boolean) {
    this.showCandidatelinkName = value;
  }

  checkCenterManager(assignedTo) {
    if (assignedTo.length == 0) {
      this.noCenterManagerFlag = true;
    } else {
      for (var i = 0; i < assignedTo.length; i++) {
        if (assignedTo[i].role.centerManager == true) {
          this.setCenterMangerFlag = true;
          this.centerMngrAssignedTo = assignedTo[i].userName;
          break;
        } else {
          this.setCenterMangerFlag = false;
        }
      }
      if (this.setCenterMangerFlag) {
        return true;
      } else {
        return false;
      }
    }
  }

  async searchCandidate() {
    if (!this.candidateSearchText1.replace(/\s/g, "").length) {
      this.candidateSearchText1 = "";
      return;
    }
    if (
      this.candidateSearchText1.charAt(0) == " " ||
      this.candidateSearchText1.charAt(this.candidateSearchText1.length - 1) ==
        " "
    ) {
      this.candidateSearchText1 = this.candidateSearchText1.trim();
    }
    if (this.candidateSearchText1.length < 3) {
      return;
    }
    this.candidateSearchText = this.candidateSearchText1;
    this.candidateSearchTextTag = this.candidateSearchText;
    this.searchFlag = true;

    // this.assessmentService.setCandidateSearchText(this.candidateSearchText);
    // await this.candidateReportList(this.linkData, true);

    // this.candidateSearchText1 = "";
    // this.ngxService.stop();
  }

  resetCreateStageForm() {
    this.stageCreation.reset({
      isEdit: false,
    });
  }

  createNewStage() {
    if (this.evaluationStageList.length == this.maxStageLimit) {
      this.toastrService.warning("Maximum Stage Reached.");
      return;
    }
    this.isCreateNewStage = true;
    this.isAddMore = true;
    this.resetCreateStageForm();
  }

  cancelCreateNew() {
    this.isCreateNewStage = false;
    this.resetCreateStageForm();
  }

  AddStage() {
    this.createEvaluationStage();
    this.isAddMore = false;
    this.resetCreateStageForm();
  }

  AddStageMore() {
    this.createEvaluationStage();
    this.resetCreateStageForm();
    if (this.evaluationStageList.length == this.maxStageLimit - 1) {
      this.isAddMore = false;
      this.toastrService.warning("Maximum Stage Reached.");
      return;
    } else {
      this.isAddMore = true;
    }
  }

  removeStageAdd() {
    this.nameControl.reset();
    if (this.evaluationStageList.length == 0) {
      this.isCreateNewStage = false;
    } else {
      this.isAddMore = false;
    }
  }

  stageId: any;
  editStage(index: number, stage: any) {
    this.isStageEdit = true;
    this.editStageId = index;
    this.stageId = stage.stageId;
    this.evaluationStageList[index].isEdit = true;
    this.stageCreation.patchValue({
      stageTitle: this.evaluationStageList[index].stageTitle,
      evaluatorCandidateLimit:
        this.evaluationStageList[index].evaluatorCandidateLimit.toString(),
      isEdit: true,
    });
  }

  cancelEdit() {
    this.evaluationStageList[this.editStageId].isEdit = false;
    this.resetCreateStageForm();
    this.isStageEdit = false;
  }

  updateStageData() {
    this.stageCreation.get("isEdit").setValue(false);
    this.evaluationStageList[this.editStageId] = this.stageCreation.value;
    this.isStageEdit = false;
  }

  deleteStage(index: number) {
    this.evaluationStageList = this.evaluationStageList.filter(
      (_, i) => i !== index
    );
  }

  associateEvaluator(stage: any) {
    console.log("stage", stage);

    const payload = {
      linkId: this.batchReferenceId,
      searchBy: "",
      searchText: "",
    };
    // this.assessmentService
    //   .getAvailableEvaluator(payload, this.companyId, this.accessToken)
    //   .subscribe(
    //     (response) => {
    $("#assignedPersonalModal").modal("hide");
    const dialogRef = this.dialog.open(EvaluatorComponent, {
      width: "1000px",
      disableClose: true,
      autoFocus: false,
      position: { top: "10px" },
      hasBackdrop: true,
      restoreFocus: false,
      scrollStrategy: this.overlay.scrollStrategies.noop(), // ⭐ KEY FIX
      data: {
        linkId: this.batchReferenceId,
        stageId: stage.stageId,
        stageName: stage.stageTitle,
      },
    });

    dialogRef.afterClosed().subscribe(
      (result) => {
        console.log("result", result);

        this.getEvaluationBatchConf2();

        $("#assignedPersonalModal").modal("show");
        // });
      }
      // (error) => {
      //   this.toastrService.error(error.error.message);
      //   return;
      // }
    );
  }

  associateEvaluatorList = [];
  editRowId: number | null = null;
  tempCandidateNo: number | null = null;

  startEdit(item: any) {
    console.log("item", item);

    this.editRowId = item.userId;
    this.tempCandidateNo = item.evaluatorRoleMeta.maxCandidateLimit; // copy original value
  }

  save(stage: any, item: any) {
    item.candidateNo = this.tempCandidateNo;
    this.editRowId = null;
    this.tempCandidateNo = null;
    console.log("item", item);

    this.updateEvaluatorWorkload(stage, item);
  }

  cancel() {
    this.editRowId = null;
    this.tempCandidateNo = null;
  }

  getEvaluationBatchConf() {
    this.ngxService.start();
    const payload = {
      linkId: this.batchReferenceId,
    };
    this.assessmentService
      .getEvaluationBatchConf(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.evaluationStageList = response.message.evaluationStages;
          this.ngxService.stop();
        },
        (error) => {
          this.evaluationStageList = [];
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  getEvaluationBatchConf2() {
    this.ngxService.start();

    const payload = {
      linkId: this.batchReferenceId,
    };

    this.assessmentService
      .getEvaluationBatchConf(payload, this.companyId, this.accessToken)
      .pipe(
        switchMap((response: any) => {
          const stages = response.message.evaluationStages;
          console.log("stages", stages);

          const requests = stages.map((stage: any) =>
            this.assessmentService
              .getAssignedEvaluator(
                {
                  linkId: this.batchReferenceId,
                  stageId: stage.stageId,
                },
                this.companyId,
                this.accessToken
              )
              .pipe(
                map((evaluators: any) => ({
                  ...stage,
                  assignedEvaluator: evaluators.message,
                }))
              )
          );

          return forkJoin(requests);
        })
      )
      .subscribe({
        next: (result: any) => {
          console.log("evaluationStageList", this.evaluationStageList);

          this.evaluationStageList = result;
          this.ngxService.stop();
        },
        error: (error) => {
          this.evaluationStageList = [];
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        },
      });
  }

  getAssignEvaluatorByStageId(stage: any) {
    console.log("stage", stage);

    const payload = {
      linkId: this.batchReferenceId,
      stageId: stage.stageId,
    };
    this.assessmentService
      .getAssignedEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          let updatedEvaluator = response.message;
          this.updateStage(updatedEvaluator);
          // this.ngxService.stop();
        },
        (error) => {
          // this.evaluationStageList = [];
          // this.toastrService.error(error.error.message);
          // this.ngxService.stop();
        }
      );
  }

  updateStage(updatedStage: any) {
    console.log(updatedStage);
    console.log(this.evaluationStageList);

    const index = this.evaluationStageList.findIndex(
      (stage) => stage.stageId === updatedStage.stageId
    );

    if (index !== -1) {
      this.evaluationStageList[index] = updatedStage;

      // Important: create new reference so Angular updates template
      this.evaluationStageList = [...this.evaluationStageList];
    }
  }

  createEvaluationStage() {
    this.ngxService.start();
    let formData = this.stageCreation.value;
    const payload = {
      linkId: this.batchReferenceId,
      stageTitle: formData.stageTitle,
      candidateLimit: Number(formData.evaluatorCandidateLimit),
    };
    this.assessmentService
      .createEvaluationStage(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.toastrService.success(response.message, "Success");
          this.getEvaluationBatchConf2();
          this.ngxService.stop();
        },
        (error) => {
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  editEvaluationStage() {
    this.ngxService.start();
    let formData = this.stageCreation.value;
    const payload = {
      stageId: this.stageId,
      linkId: this.batchReferenceId,
      stageTitle: formData.stageTitle,
      candidateLimit: Number(formData.evaluatorCandidateLimit),
    };
    this.assessmentService
      .editEvaluationStage(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.toastrService.success(response.message, "Success");
          this.getEvaluationBatchConf2();
          this.isStageEdit = false;
          this.ngxService.stop();
        },
        (error) => {
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  removeEvaluationStage(stage: any) {
    this.ngxService.start();
    const payload = {
      stageId: stage.stageId,
      linkId: this.batchReferenceId,
    };
    this.assessmentService
      .removeEvaluationStage(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.toastrService.success(response.message, "Success");
          if (this.evaluationStageList.length == 1) {
            this.isCreateNewStage = false;
          }
          this.getEvaluationBatchConf2();
          this.isStageEdit = false;
          this.ngxService.stop();
        },
        (error) => {
          console.log(error.error.message);
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  deleteStageEvaluation(stage: any) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: "400px",
      hasBackdrop: true,
      restoreFocus: false,
      scrollStrategy: this.overlay.scrollStrategies.noop(), // ⭐ KEY FIX
      data: {
        title: "Delete Criteria",
        message: "Are you sure you want to delete this Evaluation Stage?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.removeEvaluationStage(stage);
        this.getEvaluationBatchConf2();
      }
    });
  }

  clearDataEvalStage() {
    this.evaluationStageList = [];
    this.isStageEdit = false;
    this.isCreateNewStage = false;
    this.isAddMore = false;
    this.resetCreateStageForm();
    $("#assignedPersonalModal").modal("hide");
  }

  removeEvaluator(evaluator: any) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: "400px",
      hasBackdrop: true,
      restoreFocus: false,
      scrollStrategy: this.overlay.scrollStrategies.noop(), // ⭐ KEY FIX
      data: {
        title: "Delete Criteria",
        message:
          "Are you sure you want to Dissociate this evaluator from this Stage?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // this.removeEvaluationStage(stage);
      }
    });
  }

  removeEvaluatorStage(id: any, stage: any) {
    this.ngxService.start();
    const payload = {
      linkId: this.batchReferenceId,
      evaluatorId: id,
    };
    this.assessmentService
      .removeEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          //  this.getAssignEvaluatorByStageId(stage);
          this.getEvaluationBatchConf2();
          this.toastrService.success(response.message);
          this.ngxService.stop();
        },
        (error) => {
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  trackByUser(index: number, item: any) {
    return item.userId;
  }

  updateEvaluatorWorkload(stage: any, evaluator: any) {
    this.ngxService.start();
    const payload = {
      linkId: this.batchReferenceId,
      stageId: stage.stageId,
      evaluatorId: evaluator.userId,
      evaluatorCandidateLimit: Number(evaluator.candidateNo),
    };
    this.assessmentService
      .updateEvaluatorWorkload(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.toastrService.success(response.message, "Success");
          this.getEvaluationBatchConf2();
          this.isStageEdit = false;
          this.ngxService.stop();
        },
        (error) => {
          this.toastrService.error(error.error.message);
          this.ngxService.stop();
        }
      );
  }

  getAvailableEvaluator() {
    const payload = {
      linkId: this.batchReferenceId,
      searchBy: "",
      searchText: "",
    };
    this.assessmentService
      .getAvailableEvaluator(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {},
        (error) => {
          this.toastrService.error(error.error.message);
        }
      );
  }

  showBatchCandidates(selectedLinkId: any) {
    let candidateListPage = "/assessment/batch-candidates/" + selectedLinkId;
    this.router.navigate([candidateListPage]);
  }

  evaluationProgressReport() {
    const payload = {
      linkId: this.batchReferenceId,
    };

    this.assessmentService
      .evaluationProgressReport(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          console.log("response", response);
          window.open(response.body.location, "_blank");
        },
        (error) => {
          this.toastrService.error(error.error.message);
        }
      );
  }
}
